import { Handle, Position } from '@xyflow/react';
import { memo } from 'react';
import { type WhoElseDoesThisItem } from '@bliks-io/contracts';
import WhoElseDoesThisCard from '../components/cards/WhoElseDoesThisCard';

export interface WhoElseDoesThisNodeData {
  value: WhoElseDoesThisItem[];
  onChange: (value: WhoElseDoesThisItem[]) => void;
  processId?: string;
  recordingId?: string;
}

const WhoElseDoesThisNode = ({ data }: { data: WhoElseDoesThisNodeData }) => {
  return (
    <div className="relative">
      <Handle
        type="target"
        position={Position.Top}
        style={{
          background: 'transparent',
          border: 'none',
          width: '10px',
          height: '10px',
          top: '-5px'
        }}
      />

      <WhoElseDoesThisCard
        value={data.value || []}
        onChange={data.onChange}
        processId={data.processId}
        recordingId={data.recordingId}
      />
    </div>
  );
};

export default memo(WhoElseDoesThisNode);
